<template>
  <div>
    <div
      v-if="savedCards.areLoading"
      class="loader"
    />
    <div
      v-else-if="savedCards.cards.length > 0"
      class="card-list"
      :class="{ 'card-list--clickable': canSelectCard }"
    >
      <div
        v-for="card in savedCards.cards"
        :key="card.creditCardId"
      >
        <label
          :class="[ 'card-list__item', { 'card-list__item--error': card.isExpired } ]"
          :for="`selectedCard${card.creditCardId}`"
        >
          <div class="card-list__item-section">
            <card-type-icon :card-type="card.cardType" />
            <p class="title title--6 dark">
              •••• {{ card.displayText }}
            </p>
          </div>

          <div class="card-list__item-section">
            <p
              v-if="card.isExpired"
              class="smaller"
            >
              Expired
            </p>

            <p
              v-else
              class="smaller"
              :class="{'danger bold': card.isExpiringSoon}"
            >
              exp. {{ card.expirationDisplay }}
            </p>

            <div
              v-if="canSelectCard && !card.isExpired"
              class="checkbox-input checkbox-input--radio checkbox-input--default checkbox-input--no-label-text"
            >
              <div class="checkbox-input__option">
                <input
                  :id="`selectedCard${card.creditCardId}`"
                  :checked="modelValue === card.creditCardId"
                  class="checkbox-input__input"
                  type="radio"
                  name="selectedCard"
                  :value="card.creditCardId"
                  @focus="$emit('saved-card-focus')"
                  @input="changeCardHandler($event.target.value)"
                >

                <div class="checkbox-input__label" />
              </div>
            </div>

            <button
              type="button"
              class="button button--icon button--small button--transparent button--danger"
              :class="{
                'button--loading': savedCards.deletingCardId === card.creditCardId
              }"
              title="Delete Payment Method"
              @click.prevent="deleteCardHandler(card)"
            >
              <span class="icon far fa-trash-alt" />
            </button>
          </div>
        </label>

        <text-input
          v-if="card.requireCvv && card.creditCardId === modelValue"
          class="spacing-left animation-flip-in-hor-top"
          type="cvv"
          :model-value="cvvInput"
          label="CVV"
          name="cvc"
          autocomplete="cc-csc"
          :validations="{
            required: true,
            cvv: {
              cardType: card.cardType
            }
          }"
          @update:model-value="$emit('cvv-input-change', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'SavedCards',

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      modelValue: {
        type: String,
        default: ''
      },
      canSelectCard: {
        type: Boolean,
        default: true
      },
      cvvInput: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('savedCards', ['savedCards'])
    },

    methods: {
      changeCardHandler(creditCardId) {
        this.$emit('cvv-input-change', '');
        this.$emit('update:modelValue', creditCardId);
      },

      deleteCardHandler(card) {
        const confirmationModalConfig = {
          ctaConfirmText: 'Confirm',
          title: 'Delete Saved Card',
          onConfirm: async () => {
            await this.$store.dispatch('savedCards/deleteCard', card.creditCardId);

            // this.$triggerGoogleTrackingEvent('RemoveCreditCard', 'Account');

            this.$triggerNewRelicEvent('RemoveCreditCard', 'Information', 'Removed Saved Credit Card');
          }
        };

        const confirmationMessage = 'Are you sure you want to delete this saved card?';

        const warningMessage = `The card ending in <b>${card.displayText}</b> is being utilized as an auto-reload payment method. Deleting this card will disable auto-reload settings for configured gift cards.`;

        if (card.isUsedToAutoReloadGiftCard) {
          Object.assign(confirmationModalConfig, { primaryText: warningMessage, secondaryText: confirmationMessage });
        }
        else {
          Object.assign(confirmationModalConfig, { primaryText: `Are you sure you want to delete the saved card ending in <b>${card.displayText}</b>?` });
        }

        this.$openModal('confirmation', confirmationModalConfig);
      }
    }
  };
</script>
